module.exports = __webpack_public_path__ + "static/image/company/pc/culture-2.ver2_0_2.jpg?0ad72156";